import { get } from './api';
import { GetRooftopFeaturesResponseDTO } from 'declarations/dto/features';

export const getRooftopFeaturesApi = async (roofTopId: string) => {
  const response = await get<GetRooftopFeaturesResponseDTO>(`/rooftop-features/${roofTopId}`);

  return response.data;
};
